<template>
  <div class="aboutSoftware">
    <div class="forchild-wrapper">
      <header class="wrapper-header">凤巢装修软件</header>
      <div class="content">
        <div class="info-side">
          <header class="info-header">凤巢1.0下载</header>
          <div class="desc-list">
            <div
              class="desc-item"
              v-for="(desc, index) in descList"
              :key="index"
            >
              {{ desc }}
            </div>
          </div>
        </div>
        <div class="download-links">
          <div
            class="link"
            @click="handleLinkClick(link)"
            v-for="(link, index) in downloadLinks"
            :key="index"
          >
            {{ link.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="softWareBox">
      <div
        class="softLogItem"
        v-for="(item, index) in list"
        :key="index"
        @click="toSoft(item.url)"
      >
        <div class="softLogoImg"><img :src="item.logImg" alt="" /></div>
        <p class="softName">{{ item.name }}</p>
        <p class="softDesc">{{ item.desc }}</p>
      </div>
    </div>
    <div class="aboutSoftwareDesc">所有软件，数据相互打通</div>
    <div class="mask" v-show="showQrcode" @click.self="showQrcode = false">
      <div class="qrcode-wrapper">
        <h2>扫描二维码下载软件</h2>
        <div id="qrcode"></div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from "qrcodejs2";
const softwareList = [
  {
    name: "柜柜软件",
    desc: "板式家具设计、拆单软件",
    url: "https://www.eggrj.com/download.html",
    logImg: require("../assets/logo.png"),
  },
  {
    name: "老版良-ERP",
    desc: "全屋定制行业的“管家婆”",
    url: "http://lbl.eggi.cn/",
    logImg: require("../assets/softLogo1.png"),
  },
  {
    name: "知户型",
    desc: "手机端画户型，全屋效果渲染",
    url: "https://www.zbjsaas.com/max/page",
    logImg: require("../assets/softLogo/zhihuxing.png"),
  },
  {
    name: "酷家乐",
    desc: "电脑家装设计，渲染",
    url:
      "https://www.kujiale.com/activity/136?kpm=qkWL.df77b93ea332fe0b.0155bd8.1608017745057",
    logImg: require("../assets/softLogo/kujiale.png"),
  },
  {
    name: "测量大师",
    desc: "定制家具测量，安装服务平台",
    url: "http://www.zcjc.vip/index.html",
    logImg: require("../assets/softLogo/celiang.png"),
  },
];
const descList = [
  "1、装修材料报价、人工报价、自动生成CAD",
  "2、门窗、衣柜、橱柜自由设计。报价",
  "3、门店客户管理、订单管理、财务记账",
  "4、手机、电脑、平板高清效果图渲染",
  "5、测量、安装工具、找安装工方便",
];
const downloadLinks = [
  {
    title: "电脑端下载",
    link:
      "https://eggrj.oss-cn-hangzhou.aliyuncs.com/forchildClient/%E9%97%A8%E7%AA%97%E6%9F%9C%20Setup%201.0.0.exe",
  },
  { title: "iPhone下载", link: "" },
  {
    title: "Android下载",
    link:
      "https://eggrj.oss-cn-hangzhou.aliyuncs.com/forchildClient/fc%20android%20v1.0.0.apk",
    async click() {
      if (this.qrcodeInstance == null) {
        this.qrcodeInstance = await new qrcode(
          document.querySelector("#qrcode"),
          {
            text:
              "https://eggrj.oss-cn-hangzhou.aliyuncs.com/forchildClient/fc%20android%20v1.0.0.apk",
            width: 400,
            height: 400,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
            correctLevel: qrcode.CorrectLevel.L, //容错率，L/M/H
          }
        );
      } else {
        this.qrcodeInstance.makeCode(
          "https://eggrj.oss-cn-hangzhou.aliyuncs.com/forchildClient/fc%20android%20v1.0.0.apk"
        );
      }
      this.showQrcode = true;
    },
  },
  { title: "IPAD", link: "" },
  { title: "Android平板", link: "" },
];
export default {
  data() {
    return {
      list: softwareList,
      descList,
      downloadLinks,
      showQrcode: false,
      qrcodeInstance: null,
    };
  },
  methods: {
    toSoft(url) {
      if (url == null || url.trim() == "") {
        this.$message("暂未上线，敬请期待");
      } else {
        window.open(url);
      }
    },
    /**
     * @param {{link:String,click: Function}} link
     */
    handleLinkClick(link) {
      if (link.click && link.click instanceof Function) {
        link.click.bind(this)();
      } else if (link.link) {
        window.open(link.link);
      } else {
        this.$message("暂未上线，敬请期待");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.aboutSoftware {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  width: 1440px;
  margin: 0 auto;
  height: auto;
  background: #f8f8f8;
  .forchild-wrapper {
    width: 750px;
    position: relative;
    font-family: PingFang SC;
    color: #333333;
    .wrapper-header {
      width: 100%;
      text-align: center;
      font-size: 26px;
      font-weight: bold;
      margin: 35px 0;
    }
    .content {
      display: flex;
      justify-content: space-between;
      .info-side {
        border-radius: 8px;
        box-shadow: 0px 3px 6px rgba(181, 181, 181, 0.16);
        background: #fff;
        .info-header {
          background: #656d80;
          padding: 10px 0;
          border-radius: 8px 8px 0px 0px;
          font-size: 18px;
          font-weight: 500;
          color: #fff;
        }
        .desc-list {
          padding: 0 25px 0 40px;
          text-align: left;
          color: #333;
          .desc-item {
            margin-top: 10px;
          }
        }
      }
      .download-links {
        .link {
          width: 240px;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          margin-bottom: 24px;
          background: #c0c3cc;
          font-size: 18px;
          color: #fff;
          border-radius: 8px;
          transition: 0.3s all ease-out;
          &:hover {
            background: #656d80;
          }
        }
      }
    }
  }
  .softWareBox {
    width: 100%;
    margin-top: 30px;
    display: flex;
    padding: 20px 0;
    .softLogItem {
      width: 20%;
      cursor: pointer;

      .softLogoImg {
        width: 120px;
        height: 120px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        > img {
          width: 100%;
        }
      }
      p {
        color: #000;
        padding: 16px 0 0;
        font-size: 13px;
        &:hover {
          text-decoration: underline;
        }
        &.softName {
          font-size: 15px;
          color: #333;
          font-weight: 600;
        }
      }
    }
  }
  .aboutSoftwareDesc {
    margin-top: 30px;
  }
  .mask {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(9, 9, 9, 0.5);
    .qrcode-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px;
      background: #fff;
      border-radius: 15px;
      h2 {
        padding: 5px;
        font-weight: bold;
      }
    }
  }
}
</style>